// src/components/T.jsx
import { useTranslation } from 'react-i18next';
import { frTranslations } from '../locales/frDict';

/**
 * Custom hook to get a translator function `tText(text)`.
 * Automatically updates when the active language changes.
 */
export function useTranslate() {
  const { i18n } = useTranslation();
  const lang = (i18n.language || 'en').split('-')[0].toLowerCase();

  const tText = (text) => {
    if (!text || typeof text !== 'string') return text;
    if (lang === 'fr') {
      return frTranslations[text] || text;
    }
    return text;
  };

  return { tText, currentLanguage: lang, changeLanguage: i18n?.changeLanguage ? i18n.changeLanguage.bind(i18n) : () => {} };
}

/**
 * Reusable Translation Component <T>.
 * Usage:
 *   <T>Welcome back to our workspace</T>
 *   or
 *   <T text="Contact Name" />
 */
export default function T({ children, text }) {
  const { tText } = useTranslate();
  const rawText = children || text;
  return <>{tText(rawText)}</>;
}
